import retainExtraPassesConstants from "@/constants/retainExtraPassesConstants"

const pages = {
  listPage() {
    return {
      name: "Retained",
      path: retainExtraPassesConstants.PATHS.LIST,
      roles: retainExtraPassesConstants.RETAIN_EXTRA_PASSES_ADMIN_ROLES,
      module: retainExtraPassesConstants.MODULE,
      dependency: retainExtraPassesConstants.ROUTE_DEPENDENCY.LIST,
      helpKey: "retain_extra_passes_v001"
    }
  }
}

export default {
  pages
}
